import * as angular from "angular";
import * as _ from "lodash";

import { Campaign } from "../../models/campaign.model";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { DataRecordHelper } from "../data-record/data-record.helper";
import { ActivityFilter } from "../../models/activity-filter.model";
import { HouseOccupant } from "../../models/house-occupant.model";
import { HouseOccupantService } from "../../services/house-occupant.service";
import { Issue } from "../../models/issue.model";
import { IssueDataProvider } from "../../data-provider/issue.dp";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { User } from "../../models/user.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import {
    ActivityDataProvider,
    ActivityInfiniteItems,
} from "../../data-provider/activity.dp";
import { House } from "../../models/house.model";
import { HouseService } from "../../services/house.service";
import { CanvassActivity } from "../canvass/canvass-activity.helper";

let ActivityListComponent = {
    selector: "vcActivityList",
    templateUrl: "/angular/components/activity/activity-list.component.html",
    bindings: {
        userId: "=?",
        campaign: "=?",
        activities: "=?",
        hid: "=?",
        user: "=?",
        email: "=?",
        pagename: "=?",
        filter: "=?",
        houseoccupants: "=?",
    },
    controller: class ActivityListController {
        // * bindings for typescript compiler *
        public userId: string;
        public campaign: Campaign;
        public activities: any;
        public hid: string;
        public user: User;
        public email: string;
        public pagename: string;
        public houseoccupants: any;
        public filter: ActivityFilter;
        // ************************************

        public essentialsMode: boolean;
        public campaignStatusId: string;
        public personLink: boolean;
        public isLeaderView: boolean;
        public warnings: object[];
        public openCanvassDialog: (canvass: object, ev: object) => void;

        private $scope: any;
        public __env: any;
        private __app_type: string;
        private toast: ToastUtils;
        private dialog: DialogUtils;

        public navigationBarService: NavigationBarHelperService;
        private permissionProvider: PermissionCheck;
        private dataProvider: ActivityDataProvider;
        private canvassActivity: CanvassActivity;
        private houseService: HouseService;
        private issueDataProvider: IssueDataProvider;
        private houseOccupantResource: HouseOccupantService;
        private dataRecordHelper: DataRecordHelper;

        public infiniteItems: ActivityInfiniteItems;
        public activityItems: any[] = [];

        constructor(
            $scope: any,
            __env: any,
            __app_type: string,
            NavigationBarHelperService: NavigationBarHelperService,
            CanvassActivity: CanvassActivity,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck,
            ActivityDataProvider: ActivityDataProvider,
            HouseService: HouseService,
            IssueDataProvider: IssueDataProvider,
            HouseOccupantService: HouseOccupantService,
            DataRecordHelper: DataRecordHelper
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.__app_type = __app_type;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;

            this.navigationBarService = NavigationBarHelperService;
            this.dataProvider = ActivityDataProvider;
            this.canvassActivity = CanvassActivity;
            this.houseService = HouseService;
            this.issueDataProvider = IssueDataProvider;
            this.houseOccupantResource = HouseOccupantService;
            this.dataRecordHelper = DataRecordHelper;

            this.essentialsMode =
                CampaignDataProvider.activeCampaign.campaignstatusid == "5";
            this.campaignStatusId =
                CampaignDataProvider.activeCampaign.campaignstatusid;
            this.personLink = true;
            this.permissionProvider = PermissionCheck;
            this.isLeaderView = this.__app_type == "LEADER";

            this.openCanvassDialog = this.canvassActivity.openCanvassDialog;

            this.$scope.$watch(
                () => this.filter,
                (newValue, oldValue) => {
                    if (
                        JSON.stringify(newValue.nonEmptyValues()) !=
                        JSON.stringify(oldValue.nonEmptyValues())
                    ) {
                        this.infiniteItems.setFilter(this.filter);
                        this.infiniteItems.reset();
                    }
                },
                true
            );
        }

        $onInit() {
            if (this.userId) {
                this.filter.uids.values = [];
                this.filter.uids.values.push(this.userId);
                this.filter.uids.selectedUsers = [{ uid: this.userId }];
                this.filter.uids.checked = true;
            }

            this.infiniteItems = new ActivityInfiniteItems(
                this.activityItems,
                this.filter,
                this.dataProvider
            );
        }

        deleteCanvass(canvass: object, ev: any): void {
            this.canvassActivity.deleteCanvass(canvass, this.dataProvider, ev);
        }

        anyActiveFilters(): boolean {
            let active = false;
            angular.forEach(this.filter, (filter: any, name: string) => {
                if (
                    filter &&
                    filter.values &&
                    filter.values.length &&
                    (!this.userId || name != "uids")
                ) {
                    active = true;
                }
            });
            return active;
        }

        openEditHouseOccupantDialog(
            houseoccupant: HouseOccupant,
            ev: any
        ): void {
            this.dialog
                .show({
                    component: "vc-house-occupant-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: false,
                    locals: {
                        selectedHoid: houseoccupant.hoid,
                        selectedHid: null,
                    },
                    ariaLabel: "Person",
                    size: "large",
                })
                .then((data: any) => {
                    houseoccupant.hofname = data.hofname;
                    houseoccupant.holname = data.holname;
                });
        }

        openViewHouseOccupantDialog(
            houseoccupant: HouseOccupant,
            ev: any
        ): void {
            this.dialog
                .show({
                    component: "vc-view-house-occupant",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: true,
                    locals: {
                        selectedHoid: houseoccupant.hoid,
                    },
                    ariaLabel: "View Person",
                    size: "large",
                })
                .then((data: any) => {
                    houseoccupant = data;
                });
        }

        openViewHouseDialog(hid: string | number, ev: any): void {
            this.dialog.show({
                component: "vc-view-house",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "View House",
                size: "large",
                locals: {
                    selectedHid: hid,
                    selectedHouse: null,
                },
            });
        }

        openDeleteHouseDialog(house: House, ev: any): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    locals: {
                        title: "Delete House?",
                    },
                })
                .then(() => {
                    this.houseService
                        .delete({ id: house.hid })
                        .then((response: object) => {
                            const json = response["data"];
                            if (json.success) {
                                this.removeActivity(house);
                                this.toast.success("House deleted");
                            } else {
                                this.toast.error();
                            }
                        });
                });
        }

        removeActivity(activity: any): void {
            this.activityItems.splice(this.activityItems.indexOf(activity), 1);
            this.infiniteItems.numLoaded_ -= 1;
        }

        openEditHouseDialog(house: House, ev: any): void {
            this.dialog
                .show({
                    component: "vc-house-form",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    locals: {
                        selectedHouse: house,
                    },
                    size: "x-large",
                })
                .then((editedHouse: House) => {
                    _.merge(house, editedHouse);
                });
        }

        openDeletePersonDialog(person: any, ev: any): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    locals: {
                        title: `Delete ${this.__env.strings.voter}?`,
                    },
                })
                .then(() => {
                    this.houseOccupantResource
                        .delete(person.hoid)
                        .then((response: object) => {
                            const json = response["data"];
                            if (json.success) {
                                this.removeActivity(person);
                                this.toast.success("Person deleted");
                            } else {
                                this.toast.error();
                            }
                        });
                });
        }

        openDeleteIssueDialog(issue: Issue, ev: any): void {
            this.dialog
                .show({
                    component: "vc-issue-delete",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Delete follow-up request",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: issue,
                    },
                })
                .then(() => {
                    this.issueDataProvider
                        .deleteIssue(issue)
                        .then((json: object) => {
                            if (json["csqstatus"] === "Deleted") {
                                this.removeActivity(issue);
                                this.toast.success("Follow-up request deleted");
                            } else {
                                this.toast.error();
                            }
                        });
                });
        }

        openDataRecord(): void {
            this.dataRecordHelper.openDataRecord(false, true);
        }

        openSummaryDialog(canvass: any, ev: any): void {
            this.dialog.show({
                component: "vc-view-summary-dialog",
                targetEvent: ev,
                scope: this.$scope,
                size: "med",
                locals: {
                    signature: canvass.signature,
                    summary: canvass.summary,
                },
            });
        }
    },
};

angular
    .module("activity")
    .component(ActivityListComponent.selector, ActivityListComponent);
